import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const BULK_PROJECT_TEAM_MEMBER_USER_ROLE_SCHEDULE_AS_OF_DATE_QUERY = gql`
  query GetBulkProjectTeamMemberUserRoleScheduleAsOfDate(
    $input: BulkProjectTeamMemberUserRoleScheduleInput!
  ) {
    bulkProjectTeamMemberUserRoleScheduleAsOfDate(input: $input) {
      userId
      roleSchedule {
        effectiveDate2
        projectRoles {
          projectRole {
            uri
            name
          }
          isPrimary
        }
      }
    }
  }
`;

export const useBulkProjectTeamMemberUserRoleScheduleAsOfDate = ({
  projectId,
  userIds,
  asOfDate,
  skip
}) => {
  const { data } = useQuery(
    BULK_PROJECT_TEAM_MEMBER_USER_ROLE_SCHEDULE_AS_OF_DATE_QUERY,
    {
      variables: { input: { projectId, userIds, asOfDate } },
      skip
    }
  );

  return {
    roleSchedulesAsOfDateByUserUri: (
      data?.bulkProjectTeamMemberUserRoleScheduleAsOfDate || []
    ).reduce((acc, result) => {
      acc[result.userId] = { effectiveRoleSchedule: result.roleSchedule };

      return acc;
    }, {})
  };
};

export const useProjectTeamMemberUserPrimaryRole = ({
  projectId,
  userId,
  skip
}) => {
  const { loading, error, data } = useQuery(
    BULK_PROJECT_TEAM_MEMBER_USER_ROLE_SCHEDULE_AS_OF_DATE_QUERY,
    {
      variables: { input: { projectId, userIds: [userId] } },
      skip,
      fetchPolicy: 'cache-and-network'
    }
  );

  const primaryProjectRole = (
    data?.bulkProjectTeamMemberUserRoleScheduleAsOfDate?.[0]?.roleSchedule
      ?.projectRoles || []
  ).find(r => r.isPrimary)?.projectRole;

  return {
    loading,
    primaryRole: primaryProjectRole
      ? { id: primaryProjectRole.uri, displayText: primaryProjectRole.name }
      : undefined,
    error
  };
};

export default useBulkProjectTeamMemberUserRoleScheduleAsOfDate;
